import React, { useState, useRef, useEffect, useCallback } from 'react';
import { normalizeMediaUrl, DEFAULT_POSTER_SVG } from '../utils/media';
import './YouTubePlayer.css';

// SVG Icons
const PlayIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>
);

const PauseIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
);

const ReplayIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/></svg>
);

const NextIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/></svg>
);

const VolumeHighIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>
);

const VolumeLowIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/></svg>
);

const VolumeMuteIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>
);

const SettingsIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>
);

const PipIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"/></svg>
);

const FullscreenEnterIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
);

const FullscreenExitIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-14v3h3v2h-5V5h2z"/></svg>
);

const ChevronRightIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
);

const ChevronLeftIcon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
);

const CheckIcon = () => (
  <svg className="check" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
);

const SeekBack10Icon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"/></svg>
);

const SeekForward10Icon = () => (
  <svg viewBox="0 0 24 24"><path fill="currentColor" d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"/></svg>
);

// Format seconds into m:ss or h:mm:ss
function formatTime(seconds) {
  if (isNaN(seconds) || seconds < 0) return '0:00';
  const s = Math.floor(seconds % 60);
  const m = Math.floor((seconds / 60) % 60);
  const h = Math.floor(seconds / 3600);
  const padSec = s < 10 ? `0${s}` : s;
  if (h > 0) {
    const padMin = m < 10 ? `0${m}` : m;
    return `${h}:${padMin}:${padSec}`;
  }
  return `${m}:${padSec}`;
}

const SPEED_OPTIONS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
const QUALITY_OPTIONS = ['Auto', '1080p HD', '720p', '480p', '360p'];

export default function YouTubePlayer({
  src,
  poster,
  title,
  autoPlay = false,
  onNext,
  onEnded,
  upNext,
  className = '',
}) {
  const containerRef = useRef(null);
  const videoRef = useRef(null);
  const progressBarRef = useRef(null);
  const hideControlsTimer = useRef(null);
  const doubleTapTimer = useRef(null);
  const lastTapRef = useRef({ time: 0, x: 0 });
  const upNextTimerRef = useRef(null);

  // Player state
  const [isPlaying, setIsPlaying] = useState(false);
  const [isEnded, setIsEnded] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [bufferedEnd, setBufferedEnd] = useState(0);
  const [volume, setVolume] = useState(1);
  const [isMuted, setIsMuted] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [quality, setQuality] = useState('Auto');
  const [isLooping, setIsLooping] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isBuffering, setIsBuffering] = useState(false);
  const [isControlsVisible, setIsControlsVisible] = useState(true);
  const [autoplayNext, setAutoplayNext] = useState(true);
  const [upNextCountdown, setUpNextCountdown] = useState(null);
  const [showUpNextOverlay, setShowUpNextOverlay] = useState(false);

  // Scrubber & hover state
  const [isDragging, setIsDragging] = useState(false);
  const [hoverPosition, setHoverPosition] = useState(null);
  const [hoverTime, setHoverTime] = useState(0);

  // Popups & overlays
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsSubmenu, setSettingsSubmenu] = useState(null); // 'speed' | 'quality'
  const [centerRipple, setCenterRipple] = useState(null); // 'play' | 'pause' | 'seek-fwd' | 'seek-back'
  const [doubleTapFeedback, setDoubleTapFeedback] = useState(null); // { side: 'left' | 'right', text: '10s' }
  const [contextMenu, setContextMenu] = useState(null); // { x, y }
  const [showStats, setShowStats] = useState(false);

  // Trigger brief animated ripple in center
  const triggerRipple = useCallback((type) => {
    setCenterRipple(type);
    setTimeout(() => {
      setCenterRipple((current) => (current === type ? null : current));
    }, 500);
  }, []);

  // Play / Pause toggle
  const togglePlay = useCallback(() => {
    if (!videoRef.current) return;
    if (videoRef.current.paused || videoRef.current.ended) {
      videoRef.current.play().then(() => {
        setIsPlaying(true);
        setIsEnded(false);
        triggerRipple('play');
      }).catch(() => {});
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
      triggerRipple('pause');
    }
  }, [triggerRipple]);

  // Seek helper
  const seekRelative = useCallback((seconds) => {
    if (!videoRef.current) return;
    const newTime = Math.max(0, Math.min(videoRef.current.duration || 0, videoRef.current.currentTime + seconds));
    videoRef.current.currentTime = newTime;
    setCurrentTime(newTime);
    triggerRipple(seconds > 0 ? 'seek-fwd' : 'seek-back');
  }, [triggerRipple]);

  // Volume & Mute handlers
  const handleVolumeChange = useCallback((newVol) => {
    const clamped = Math.max(0, Math.min(1, newVol));
    setVolume(clamped);
    if (videoRef.current) {
      videoRef.current.volume = clamped;
      videoRef.current.muted = clamped === 0;
      setIsMuted(clamped === 0);
    }
  }, []);

  const toggleMute = useCallback(() => {
    if (!videoRef.current) return;
    if (isMuted || volume === 0) {
      const restored = volume === 0 ? 0.8 : volume;
      videoRef.current.muted = false;
      videoRef.current.volume = restored;
      setIsMuted(false);
      setVolume(restored);
    } else {
      videoRef.current.muted = true;
      setIsMuted(true);
    }
  }, [isMuted, volume]);

  // Fullscreen handlers
  const toggleFullscreen = useCallback(() => {
    if (!containerRef.current) return;
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen?.().catch(() => {});
    } else {
      document.exitFullscreen?.().catch(() => {});
    }
  }, []);

  // Picture in Picture
  const togglePip = async () => {
    if (!videoRef.current) return;
    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      } else if (document.pictureInPictureEnabled) {
        await videoRef.current.requestPictureInPicture();
      }
    } catch (e) {
      console.error('PiP failed', e);
    }
  };

  // Autohide controls timer
  const resetHideTimer = useCallback(() => {
    setIsControlsVisible(true);
    if (hideControlsTimer.current) clearTimeout(hideControlsTimer.current);
    if (isPlaying && !settingsOpen && !contextMenu && !isDragging) {
      hideControlsTimer.current = setTimeout(() => {
        setIsControlsVisible(false);
      }, 2500);
    }
  }, [isPlaying, settingsOpen, contextMenu, isDragging]);

  useEffect(() => {
    const handleFsChange = () => {
      setIsFullscreen(Boolean(document.fullscreenElement));
    };
    document.addEventListener('fullscreenchange', handleFsChange);
    return () => document.removeEventListener('fullscreenchange', handleFsChange);
  }, []);

  // Up Next autoplay countdown timer
  useEffect(() => {
    if (showUpNextOverlay && upNextCountdown !== null) {
      if (upNextCountdown > 0) {
        upNextTimerRef.current = setTimeout(() => {
          setUpNextCountdown((c) => (c !== null && c > 0 ? c - 1 : 0));
        }, 1000);
      } else if (upNextCountdown === 0) {
        setShowUpNextOverlay(false);
        setUpNextCountdown(null);
        if (upNext?.onPlay) upNext.onPlay();
        else if (onNext) onNext();
      }
    }
    return () => {
      if (upNextTimerRef.current) clearTimeout(upNextTimerRef.current);
    };
  }, [showUpNextOverlay, upNextCountdown, upNext, onNext]);

  // Reset when src changes
  useEffect(() => {
    setIsEnded(false);
    setShowUpNextOverlay(false);
    setUpNextCountdown(null);
    if (upNextTimerRef.current) clearTimeout(upNextTimerRef.current);
  }, [src]);

  const handleEnded = () => {
    setIsPlaying(false);
    setIsEnded(true);
    if (upNext && autoplayNext) {
      setShowUpNextOverlay(true);
      setUpNextCountdown(5);
    }
    if (onEnded) onEnded();
  };

  const handlePlayUpNextNow = () => {
    setShowUpNextOverlay(false);
    setUpNextCountdown(null);
    if (upNext?.onPlay) upNext.onPlay();
    else if (onNext) onNext();
  };

  const handleCancelUpNext = () => {
    setShowUpNextOverlay(false);
    setUpNextCountdown(null);
    if (upNextTimerRef.current) clearTimeout(upNextTimerRef.current);
  };

  // Update buffer & current time
  const handleTimeUpdate = () => {
    if (!videoRef.current) return;
    setCurrentTime(videoRef.current.currentTime);
    const buffered = videoRef.current.buffered;
    if (buffered.length > 0) {
      for (let i = buffered.length - 1; i >= 0; i--) {
        if (buffered.start(i) <= videoRef.current.currentTime) {
          setBufferedEnd(buffered.end(i));
          break;
        }
      }
    }
  };

  // Scrubber scrubbing / click calculations
  const calculateProgressFromEvent = (e) => {
    if (!progressBarRef.current) return 0;
    const rect = progressBarRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const pos = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    return pos;
  };

  const handleProgressBarMouseDown = (e) => {
    e.stopPropagation();
    setIsDragging(true);
    const pos = calculateProgressFromEvent(e);
    if (videoRef.current && duration > 0) {
      const newTime = pos * duration;
      videoRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  const handleProgressBarMouseMove = (e) => {
    if (!progressBarRef.current || duration <= 0) return;
    const pos = calculateProgressFromEvent(e);
    setHoverPosition(pos);
    setHoverTime(pos * duration);
  };

  const handleProgressBarMouseLeave = () => {
    setHoverPosition(null);
  };

  useEffect(() => {
    const onWindowMouseMove = (e) => {
      if (isDragging && progressBarRef.current && duration > 0) {
        const pos = calculateProgressFromEvent(e);
        if (videoRef.current) {
          const newTime = pos * duration;
          videoRef.current.currentTime = newTime;
          setCurrentTime(newTime);
        }
      }
    };
    const onWindowMouseUp = () => {
      if (isDragging) setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener('mousemove', onWindowMouseMove);
      window.addEventListener('mouseup', onWindowMouseUp);
      window.addEventListener('touchmove', onWindowMouseMove);
      window.addEventListener('touchend', onWindowMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', onWindowMouseMove);
      window.removeEventListener('mouseup', onWindowMouseUp);
      window.removeEventListener('touchmove', onWindowMouseMove);
      window.removeEventListener('touchend', onWindowMouseUp);
    };
  }, [isDragging, duration]);

  // Speed change
  const handleSpeedChange = (speed) => {
    setPlaybackSpeed(speed);
    if (videoRef.current) videoRef.current.playbackRate = speed;
    setSettingsOpen(false);
    setSettingsSubmenu(null);
  };

  // Loop toggle
  const toggleLoop = () => {
    const next = !isLooping;
    setIsLooping(next);
    if (videoRef.current) videoRef.current.loop = next;
    setSettingsOpen(false);
  };

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Don't intercept if user is typing in an input
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target?.tagName)) return;

      const key = e.key.toLowerCase();
      if (key === ' ' || key === 'k') {
        e.preventDefault();
        togglePlay();
      } else if (key === 'f') {
        e.preventDefault();
        toggleFullscreen();
      } else if (key === 'm') {
        e.preventDefault();
        toggleMute();
      } else if (key === 'j') {
        e.preventDefault();
        seekRelative(-10);
      } else if (key === 'l') {
        e.preventDefault();
        seekRelative(10);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        seekRelative(-5);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        seekRelative(5);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        handleVolumeChange(volume + 0.05);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        handleVolumeChange(volume - 0.05);
      } else if (key >= '0' && key <= '9') {
        e.preventDefault();
        if (videoRef.current && duration > 0) {
          const frac = parseInt(key, 10) / 10;
          videoRef.current.currentTime = frac * duration;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [togglePlay, toggleFullscreen, toggleMute, seekRelative, handleVolumeChange, volume, duration]);

  // Video click & double click handler for quick 10s seek
  const handleVideoAreaClick = (e) => {
    // Close context menu / settings if open
    if (contextMenu) setContextMenu(null);
    if (settingsOpen) {
      setSettingsOpen(false);
      setSettingsSubmenu(null);
      return;
    }

    const now = Date.now();
    const rect = containerRef.current?.getBoundingClientRect();
    const clickX = e.clientX - (rect?.left || 0);
    const width = rect?.width || 1;
    const isLeftSide = clickX < width * 0.35;
    const isRightSide = clickX > width * 0.65;

    if (now - lastTapRef.current.time < 300) {
      // Double click detected
      clearTimeout(doubleTapTimer.current);
      if (isLeftSide) {
        seekRelative(-10);
        setDoubleTapFeedback({ side: 'left', text: '10 seconds' });
      } else if (isRightSide) {
        seekRelative(10);
        setDoubleTapFeedback({ side: 'right', text: '10 seconds' });
      } else {
        toggleFullscreen();
      }
      setTimeout(() => setDoubleTapFeedback(null), 600);
      lastTapRef.current = { time: 0, x: clickX };
    } else {
      lastTapRef.current = { time: now, x: clickX };
      doubleTapTimer.current = setTimeout(() => {
        togglePlay();
      }, 300);
    }
  };

  // Custom right click context menu
  const handleContextMenu = (e) => {
    e.preventDefault();
    const rect = containerRef.current.getBoundingClientRect();
    setContextMenu({
      x: Math.min(e.clientX - rect.left, rect.width - 190),
      y: Math.min(e.clientY - rect.top, rect.height - 180),
    });
  };

  const playedPercent = duration > 0 ? (currentTime / duration) * 100 : 0;
  const bufferPercent = duration > 0 ? (bufferedEnd / duration) * 100 : 0;
  const hoverPercent = hoverPosition !== null ? hoverPosition * 100 : 0;

  return (
    <div
      ref={containerRef}
      className={`yt-player-container ${!isControlsVisible && isPlaying ? 'yt-cursor-hidden yt-controls-hidden' : ''} ${className}`}
      onMouseMove={resetHideTimer}
      onMouseEnter={resetHideTimer}
      onContextMenu={handleContextMenu}
      onClick={() => {
        if (contextMenu) setContextMenu(null);
      }}
      tabIndex={0}
    >
      {/* Underlying HTML5 Video */}
      <video
        ref={videoRef}
        className="yt-video-element"
        src={src}
        poster={normalizeMediaUrl(poster) || undefined}
        autoPlay={autoPlay}
        playsInline
        preload="metadata"
        disablePictureInPicture={false}
        controlsList="nodownload"
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={() => {
          if (videoRef.current) {
            setDuration(videoRef.current.duration);
            videoRef.current.playbackRate = playbackSpeed;
          }
        }}
        onWaiting={() => setIsBuffering(true)}
        onPlaying={() => {
          setIsBuffering(false);
          setIsPlaying(true);
          setIsEnded(false);
        }}
        onPause={() => setIsPlaying(false)}
        onEnded={handleEnded}
        onClick={handleVideoAreaClick}
      />

      {/* Top Gradient & Title Bar */}
      <div className="yt-top-gradient" />
      {title && (
        <div className="yt-top-bar">
          <span className="yt-top-title">{title}</span>
          <span className="yt-top-brand">▶ ZIME</span>
        </div>
      )}

      {/* Buffering Spinner */}
      {isBuffering && <div className="yt-spinner" />}

      {/* Classic YouTube Up Next End Screen Overlay */}
      {showUpNextOverlay && upNext && (
        <div className="yt-upnext-overlay" onClick={(e) => e.stopPropagation()}>
          <div className="yt-upnext-card">
            <div className="yt-upnext-header">
              UP NEXT IN <span>{upNextCountdown ?? 5}s</span>
            </div>
            <div className="yt-upnext-preview">
              <div className="yt-upnext-art">
                <img
                  src={normalizeMediaUrl(upNext.thumbnail || poster) || DEFAULT_POSTER_SVG}
                  alt={upNext.title}
                  referrerPolicy="no-referrer"
                  onError={(e) => { e.currentTarget.src = DEFAULT_POSTER_SVG; }}
                />
                <PlayIcon />
              </div>
              <div className="yt-upnext-info">
                {upNext.subtitle && <span className="yt-upnext-sub">{upNext.subtitle}</span>}
                <span className="yt-upnext-title">{upNext.title}</span>
              </div>
            </div>
            <div className="yt-upnext-actions">
              <button className="yt-upnext-cancel-btn" onClick={handleCancelUpNext}>
                Cancel
              </button>
              <button className="yt-upnext-play-btn" onClick={handlePlayUpNextNow}>
                <PlayIcon /> Play Now
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Center Big Play Button (when stopped / ended and not showing Up Next) */}
      {!isPlaying && !isBuffering && !showUpNextOverlay && (
        <div className="yt-center-action">
          <button className="yt-big-play-btn" onClick={togglePlay} aria-label={isEnded ? 'Replay' : 'Play'}>
            {isEnded ? <ReplayIcon /> : <PlayIcon />}
          </button>
        </div>
      )}

      {/* Center Ripple Feedback for Shortcuts / Clicks */}
      {centerRipple && (
        <div className="yt-center-ripple">
          {centerRipple === 'play' && <PlayIcon />}
          {centerRipple === 'pause' && <PauseIcon />}
          {centerRipple === 'seek-fwd' && <SeekForward10Icon />}
          {centerRipple === 'seek-back' && <SeekBack10Icon />}
        </div>
      )}

      {/* Double Tap Seek Feedback */}
      {doubleTapFeedback && (
        <div className={`yt-double-tap-indicator ${doubleTapFeedback.side}`}>
          {doubleTapFeedback.side === 'left' ? <SeekBack10Icon /> : <SeekForward10Icon />}
          <span>{doubleTapFeedback.text}</span>
        </div>
      )}

      {/* Bottom Gradient Overlay */}
      <div className="yt-bottom-gradient" />

      {/* Bottom Controls Container */}
      <div className="yt-controls" onClick={(e) => e.stopPropagation()}>
        {/* Progress Bar / Scrubber */}
        <div
          ref={progressBarRef}
          className={`yt-progress-bar-container ${isDragging ? 'dragging' : ''}`}
          onMouseDown={handleProgressBarMouseDown}
          onMouseMove={handleProgressBarMouseMove}
          onMouseLeave={handleProgressBarMouseLeave}
          onTouchStart={handleProgressBarMouseDown}
        >
          <div className="yt-progress-bar-bg">
            <div className="yt-progress-buffer" style={{ width: `${bufferPercent}%` }} />
            {hoverPosition !== null && (
              <div className="yt-progress-hover" style={{ width: `${hoverPercent}%` }} />
            )}
            <div className="yt-progress-played" style={{ width: `${playedPercent}%` }} />
            <div className="yt-scrubber-handle" style={{ left: `${playedPercent}%` }} />
          </div>

          {/* Scrubber Tooltip */}
          {hoverPosition !== null && (
            <div className="yt-hover-time" style={{ left: `${hoverPercent}%` }}>
              {formatTime(hoverTime)}
            </div>
          )}
        </div>

        {/* Buttons Row */}
        <div className="yt-controls-row">
          {/* Left Controls */}
          <div className="yt-controls-left">
            {/* Play / Pause / Replay Button */}
            <button className="yt-btn" onClick={togglePlay} aria-label={isPlaying ? 'Pause (k)' : isEnded ? 'Replay' : 'Play (k)'}>
              {isEnded ? <ReplayIcon /> : isPlaying ? <PauseIcon /> : <PlayIcon />}
            </button>

            {/* Next Episode / Video Button */}
            {(onNext || upNext) && (
              <button
                className="yt-btn"
                onClick={handlePlayUpNextNow}
                aria-label="Next episode"
                title={upNext?.title ? `Next: ${upNext.title}` : 'Next episode'}
              >
                <NextIcon />
              </button>
            )}

            {/* Volume Container */}
            <div className="yt-volume-container">
              <button className="yt-btn" onClick={toggleMute} aria-label={isMuted ? 'Unmute (m)' : 'Mute (m)'}>
                {isMuted || volume === 0 ? <VolumeMuteIcon /> : volume < 0.5 ? <VolumeLowIcon /> : <VolumeHighIcon />}
              </button>
              <div className="yt-volume-slider-wrapper">
                <input
                  type="range"
                  min="0"
                  max="1"
                  step="0.05"
                  value={isMuted ? 0 : volume}
                  onChange={(e) => handleVolumeChange(parseFloat(e.target.value))}
                  className="yt-volume-slider"
                  aria-label="Volume"
                />
              </div>
            </div>

            {/* Time Stamp Display */}
            <div className="yt-time-display">
              <span className="yt-time-current">{formatTime(currentTime)}</span>
              <span className="yt-time-separator">/</span>
              <span className="yt-time-duration">{formatTime(duration)}</span>
            </div>
          </div>

          {/* Right Controls */}
          <div className="yt-controls-right">
            {/* Autoplay Toggle Switch */}
            {(onNext || upNext) && (
              <div className="yt-autoplay-toggle" title={`Autoplay next is ${autoplayNext ? 'ON' : 'OFF'}`}>
                <button
                  className="yt-autoplay-btn"
                  onClick={() => setAutoplayNext(!autoplayNext)}
                  aria-label="Toggle autoplay"
                >
                  <div className={`yt-toggle-track ${autoplayNext ? 'active' : ''}`}>
                    <div className="yt-toggle-thumb">
                      {autoplayNext && <PlayIcon />}
                    </div>
                  </div>
                </button>
              </div>
            )}

            {/* Settings Gear */}
            <button
              className="yt-btn"
              onClick={() => {
                setSettingsOpen(!settingsOpen);
                setSettingsSubmenu(null);
              }}
              aria-label="Settings"
            >
              <SettingsIcon />
            </button>

            {/* Picture in Picture */}
            {document.pictureInPictureEnabled && (
              <button className="yt-btn" onClick={togglePip} aria-label="Picture in Picture">
                <PipIcon />
              </button>
            )}

            {/* Fullscreen Button */}
            <button className="yt-btn" onClick={toggleFullscreen} aria-label={isFullscreen ? 'Exit Fullscreen (f)' : 'Fullscreen (f)'}>
              {isFullscreen ? <FullscreenExitIcon /> : <FullscreenEnterIcon />}
            </button>
          </div>
        </div>
      </div>

      {/* Settings Menu Popover */}
      {settingsOpen && (
        <div className="yt-settings-menu" onClick={(e) => e.stopPropagation()}>
          {!settingsSubmenu && (
            <>
              <div className="yt-menu-item" onClick={() => setSettingsSubmenu('speed')}>
                <div className="yt-menu-item-left">
                  <span>Playback speed</span>
                </div>
                <div className="yt-menu-value">
                  <span>{playbackSpeed === 1 ? 'Normal' : `${playbackSpeed}x`}</span>
                  <ChevronRightIcon />
                </div>
              </div>

              <div className="yt-menu-item" onClick={() => setSettingsSubmenu('quality')}>
                <div className="yt-menu-item-left">
                  <span>Quality</span>
                </div>
                <div className="yt-menu-value">
                  <span>{quality}</span>
                  <ChevronRightIcon />
                </div>
              </div>

              <div className="yt-menu-item" onClick={toggleLoop}>
                <div className="yt-menu-item-left">
                  <span>Loop</span>
                </div>
                <div className="yt-menu-value">
                  <span>{isLooping ? 'On' : 'Off'}</span>
                </div>
              </div>
            </>
          )}

          {settingsSubmenu === 'speed' && (
            <>
              <div className="yt-menu-header" onClick={() => setSettingsSubmenu(null)}>
                <ChevronLeftIcon />
                <span>Playback speed</span>
              </div>
              {SPEED_OPTIONS.map((speed) => (
                <div
                  key={speed}
                  className={`yt-menu-item ${playbackSpeed === speed ? 'active' : ''}`}
                  onClick={() => handleSpeedChange(speed)}
                >
                  <div className="yt-menu-item-left">
                    {playbackSpeed === speed ? <CheckIcon /> : <span style={{ width: 18 }} />}
                    <span>{speed === 1 ? 'Normal' : `${speed}x`}</span>
                  </div>
                </div>
              ))}
            </>
          )}

          {settingsSubmenu === 'quality' && (
            <>
              <div className="yt-menu-header" onClick={() => setSettingsSubmenu(null)}>
                <ChevronLeftIcon />
                <span>Quality</span>
              </div>
              {QUALITY_OPTIONS.map((q) => (
                <div
                  key={q}
                  className={`yt-menu-item ${quality === q ? 'active' : ''}`}
                  onClick={() => {
                    setQuality(q);
                    setSettingsOpen(false);
                    setSettingsSubmenu(null);
                  }}
                >
                  <div className="yt-menu-item-left">
                    {quality === q ? <CheckIcon /> : <span style={{ width: 18 }} />}
                    <span>{q}</span>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      )}

      {/* Classic YouTube Context Menu */}
      {contextMenu && (
        <div
          className="yt-context-menu"
          style={{ top: contextMenu.y, left: contextMenu.x }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="yt-context-item"
            onClick={() => {
              toggleLoop();
              setContextMenu(null);
            }}
          >
            <span>Loop</span>
            {isLooping && <CheckIcon />}
          </div>
          <div
            className="yt-context-item"
            onClick={() => {
              navigator.clipboard?.writeText(window.location.href);
              setContextMenu(null);
            }}
          >
            <span>Copy video URL</span>
          </div>
          <div
            className="yt-context-item"
            onClick={() => {
              const urlWithTime = `${window.location.href.split('?')[0]}?t=${Math.floor(currentTime)}`;
              navigator.clipboard?.writeText(urlWithTime);
              setContextMenu(null);
            }}
          >
            <span>Copy video URL at current time</span>
          </div>
          <div
            className="yt-context-item"
            onClick={() => {
              setShowStats(!showStats);
              setContextMenu(null);
            }}
          >
            <span>Stats for nerds</span>
          </div>
        </div>
      )}

      {/* Stats for Nerds Panel */}
      {showStats && (
        <div className="yt-stats-panel" onClick={(e) => e.stopPropagation()}>
          <div className="yt-stats-header">
            <span>Stats for nerds</span>
            <button className="yt-stats-close" onClick={() => setShowStats(false)}>✕</button>
          </div>
          <div className="yt-stats-row">
            <span className="yt-stats-label">Video ID / Title:</span>
            <span>{title || 'Zime Stream'}</span>
          </div>
          <div className="yt-stats-row">
            <span className="yt-stats-label">Dimensions / Res:</span>
            <span>{videoRef.current ? `${videoRef.current.videoWidth || 1920}x${videoRef.current.videoHeight || 1080}` : '1920x1080'}</span>
          </div>
          <div className="yt-stats-row">
            <span className="yt-stats-label">Volume / State:</span>
            <span>{Math.round(volume * 100)}% / {isPlaying ? 'Playing' : 'Paused'}</span>
          </div>
          <div className="yt-stats-row">
            <span className="yt-stats-label">Buffer Health:</span>
            <span>{Math.max(0, Math.round(bufferedEnd - currentTime))} s</span>
          </div>
          <div className="yt-stats-row">
            <span className="yt-stats-label">Playback Rate:</span>
            <span>{playbackSpeed}x</span>
          </div>
        </div>
      )}
    </div>
  );
}
